<template>
    <div class="banner">
        <div class="row items-center full-width no-wrap">
            <div class="q-mr-md">
                <slot name="icon" />
            </div>
            <div class="row flex-grow gap-l" :class="{ 'no-wrap': $q.screen.gt.sm }">
                <div>
                    <slot name="content" />
                </div>
                <div class="row items-center flex-grow justify-end gap-m" :class="{ 'no-wrap': $q.screen.gt.sm }">
                    <slot name="actions" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.banner {
    display: flex;
    flex-direction: row;
    border-radius: $default-border-radius;
    background-color: $warning-color-light;
    padding: 12px;
    gap: $spacing-l;
}
</style>
